import { useEffect } from 'react';
import { sendLiveRegionMessage } from '../../../../../../atoms/LiveRegionGlobal/LiveRegionGlobal';
import { useSonTranslation } from '../../../../../../../translation/useSonTranslation';
import { IEntity } from '../../../../../../../types/api/entities/IEntity';

type useSonTranslationProps = {
  allResults: IEntity[] | undefined;
  loading: boolean;
  error?: 'noData' | 'invalidSearchTerm';
  resultsOpen: boolean;
  inputValue?: string;
};

export function useComboBoxLiveRegionMessage({
  allResults,
  loading,
  error,
  resultsOpen,
  inputValue,
}: useSonTranslationProps) {
  const { t } = useSonTranslation('FormsComboBox');

  useEffect(() => {
    if (!resultsOpen) {
      return;
    }

    if (allResults && allResults.length > 0) {
      sendLiveRegionMessage(`${allResults.length} ${t('resultsAvailable')}`);
      // we need a dependency on inputValue, because we don't want to have a live region message
      // when nothing is typed, or we leave the page (in this case, the input is empty, too), see SON-16498
    } else if (inputValue && inputValue !== '') {
      sendLiveRegionMessage(t('noResults'));
    }

    // need to stringify first, since new array is detected as a change even if the content is the same.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(allResults)]);

  useEffect(() => {
    if (loading) {
      sendLiveRegionMessage(t('loading'));
    }

    // t is pure
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  useEffect(() => {
    if (error) {
      sendLiveRegionMessage(t(`error.${error}`));
    }

    // t is pure
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);
}
